import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { slugs } from '../Constant/slugs';
import '../styles.css'
import { sideBarImage } from '../Constant/api';
const SideBarBlock = ({
  allSlug, newSlug, location,
  Title, icon, setExpand, Expand,
  setMenuExpand
}) => {
  return (
    <div>
      <div className={location.pathname == allSlug ? "row active-sidebar" : "row passive-sidebar"}

      >
        <Link className={"Link col-10"} to={allSlug}>
          <div className={location.pathname == allSlug ? "active-sidebar-font" : "passive-sidebar-font"}
            onClick={() => {
              setMenuExpand(false)
            }}
          >
            &nbsp; &nbsp;{Title}
          </div>
        </Link>
        {newSlug !== "" &&
          <div className="col-1" style={{ cursor: 'pointer' }}
            onClick={() => {
              setExpand(!Expand)
            }}>
            <i className={Expand ? "fa fa-minus" : "fa fa-plus"} style={{ fontSize: "10px" }} />
          </div>
        }
      </div>
      {Expand && newSlug !== "" &&
        <>
          <Link className={location.pathname == allSlug ? "Link active-sidebar" : "Link passive-sidebar"}
            style={{ paddingLeft: "40px" }}
            to={allSlug}
          >
            <div className={location.pathname == allSlug ? "Link active-sidebar-font" : "Link passive-sidebar-font"}>
              All {Title}
            </div>
          </Link>
          <Link className={location.pathname == `/${newSlug}` ? "Link active-sidebar" : "Link passive-sidebar"}
            style={{ paddingLeft: "40px" }}
            to={newSlug}
          >
            <div className={location.pathname == `/newSlug` ? "active-sidebar-font" : "passive-sidebar-font"}>
              Add New {Title.slice(0, -1)}
            </div>
          </Link>
        </>
      }
    </div>
  )
}
const type_array = {
  "ubt": "ubt",
  "loksewa": "loksewa",
  "banking": "banking",
  "tsc": "tsc",
}
export default function SideBar({ setMenuExpand }) {
  const LoginUser = useSelector((state) => state.LoginState);
  const [Menu, setMenu] = React.useState(false)
  const location = useLocation()

  const [ExamExpand, setExamExpand] = React.useState(false)
  const [DemoExamExpand, setDemoExamExpand] = React.useState(false)
  const [DailyExamExpand, setDailyExamExpand] = React.useState(false)
  const [ChapterWiseExamExpand, setChapterWiseExamExpand] = React.useState(false)
  const [BookExpand, setBookExpand] = React.useState(false)
  const [StudentExpand, setStudentExpand] = React.useState(false)
  const [BatchExpand, setBatchExpand] = React.useState(false)
  const [DailyResultsExpand, setDailyResultsExpand] = React.useState(false)
  const [ExamResultsExpand, setExamResultsExpand] = React.useState(false)
  const [BatchOrdersExpand, setBatchOrdersExpand] = React.useState(false)
  const [OrdersExpand, setOrdersExpand] = React.useState(false)

  return (
    <div>
      <div className="small-display-none">
        <div style={{ justifyContent: 'center', display: 'flex', padding: "30px", borderBottom: "1px solid #eee" }}>
          <img
            src={sideBarImage}
            style={{ width: "200px", height: "100px", objectFit: 'contain' }}
          />
        </div>
      </div>

      <div className="small-display-block">
        <div className="row passive-sidebar" onClick={() => { setMenuExpand(false) }}>
          <div className={"passive-sidebar-font"}>
            <i className="fa fa-close" style={{ fontSize: "16px" }} />&nbsp; &nbsp;Close
          </div>
        </div>
      </div>
      {/* Home */}
      {/* {LoginUser.userRole} */}
      {LoginUser.userRole == "author" &&
        <>
          {/* <div className="row" className={location.pathname == "/" ? "active-sidebar" : "passive-sidebar"}>
            <Link className={"Link col-10"} to={`/`}>
              <div className={location.pathname == "/" ? "active-sidebar-font" : "passive-sidebar-font"}>
                <i className="fa fa-home" style={{ fontSize: "16px" }} />&nbsp; &nbsp;Home
              </div>
            </Link>
          </div> */}
          <SideBarBlock
            allSlug={slugs.all_demo_exam} newSlug={slugs.new_demo_exam}
            location={location} Title={"Demo Exams"}
            icon={""}
            setExpand={setDemoExamExpand}
            Expand={DemoExamExpand}

          />
          <SideBarBlock
            allSlug={slugs.all_weekly_exam} newSlug={slugs.new_weekly_exam}
            location={location} Title={"Weekly Exams"}
            icon={""}
            setExpand={ExamExpand} Expand={setExamExpand}

          />
          <SideBarBlock
            allSlug={`${slugs.all_exam}/${type_array.ubt}`} newSlug={`${slugs.new_exam}/${type_array.ubt}`}
            location={location} Title={"Korean Exams"}
            icon={""}
            Expand={ExamExpand}
            setExpand={setExamExpand}
          />
          <SideBarBlock
            allSlug={`${slugs.all_exam}/${type_array.loksewa}`} newSlug={`${slugs.new_exam}/${type_array.ubt}`}
            location={location} Title={"Loksewa Exams"}
            icon={""}
            Expand={ExamExpand}
            setExpand={setExamExpand}
          />
          <SideBarBlock
            allSlug={`${slugs.all_exam}/${type_array.banking}`} newSlug={`${slugs.new_exam}/${type_array.ubt}`}
            location={location} Title={"Banking Exams"}
            icon={""}
            Expand={ExamExpand}
            setExpand={setExamExpand}
          />
          <SideBarBlock
            allSlug={`${slugs.all_exam}/${type_array.tsc}`} newSlug={`${slugs.new_exam}/${type_array.ubt}`}
            location={location} Title={"TSC Exams"}
            icon={""}
            Expand={ExamExpand}
            setExpand={setExamExpand}
          />

          {/* <SideBarBlock
            allSlug={slugs.all_exam} newSlug={slugs.new_exam}
            location={location} Title={"Exams"}
            icon={""}
            Expand={ExamExpand}
            setExpand={setExamExpand}
          /> */}
          <SideBarBlock
            allSlug={slugs.all_books} newSlug={slugs.new_book}
            location={location} Title={"All Books"}
            icon={""}
            setExpand={setBookExpand} Expand={BookExpand}

          />
          <SideBarBlock
            allSlug={slugs.all_orders} newSlug={slugs.new_order}
            location={location} Title={"Exam Orders"}
            icon={""}
            setExpand={setOrdersExpand} Expand={OrdersExpand}

          />
          <SideBarBlock
            allSlug={slugs.all_batch_orders} newSlug={slugs.new_batch_order}
            location={location} Title={"Batch Orders"}
            icon={""}
            setExpand={setBatchOrdersExpand} Expand={BatchOrdersExpand}

          />
          <SideBarBlock
            allSlug={slugs.all_daily_results} newSlug={""}
            location={location} Title={"Batch Results"}
            icon={""}
            setExpand={setDailyExamExpand} Expand={BookExpand}

          />
          <SideBarBlock
            allSlug={slugs.all_weekly_results} newSlug={""}
            location={location} Title={"Weekly Results"}
            icon={""}
            setExpand={setDailyExamExpand} Expand={BookExpand}

          />
          <SideBarBlock
            allSlug={slugs.all_results} newSlug={""}
            location={location} Title={"Exam Results"}
            icon={""}
            setExpand={setBookExpand} Expand={BookExpand}

          />
          <SideBarBlock
            allSlug={slugs.all_students} newSlug={slugs.new_student}
            location={location} Title={"Students"}
            icon={""}
            setExpand={setStudentExpand} Expand={StudentExpand}

          />
          {/* <SideBarBlock
            allSlug={slugs.all_teachers} newSlug={slugs.new_teacher}
            location={location} Title={"Teachers"}
            icon={""}
            setExpand={setBatchExpand} Expand={BatchExpand}
           
          /> */}

          <SideBarBlock
            allSlug={slugs.all_batch} newSlug={slugs.new_batch}
            location={location} Title={"Batch"}
            icon={""}
            setExpand={setBatchExpand} Expand={BatchExpand}

          />
          <SideBarBlock
            allSlug={"/Images"} newSlug={""}
            location={location} Title={"Images"}
            icon={""}
            Expand={DemoExamExpand}
            setExpand={setDemoExamExpand}
          />
          <SideBarBlock
            allSlug={"/color-vision-admin"} newSlug={""}
            location={location} Title={"Color Vision"}
            icon={""}
            setExpand={setStudentExpand} Expand={StudentExpand}
            setMenuExpand={setMenuExpand}
          />
          <div className="row active-sidebar">
            Student Panel
          </div>
        </>
      }
      <SideBarBlock
        allSlug={slugs.start_demo_exam} newSlug={""}
        location={location} Title={"Demo Exam"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}

      />
      <SideBarBlock
        allSlug={slugs.weekly_exam} newSlug={""}
        location={location} Title={"Weekly Free Exam"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}

      />
      <SideBarBlock
        allSlug={slugs.exam} newSlug={""}
        location={location} Title={"Korean Exam "}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}

      />
      <SideBarBlock
        allSlug={`${slugs.exam}/${type_array.loksewa}`} newSlug={""}
        location={location} Title={"Loksewa Exam"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}

      />
      <SideBarBlock
        allSlug={`${slugs.exam}/${type_array.banking}`} newSlug={""}
        location={location} Title={"Banking Exam"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}

      />
      <SideBarBlock
        allSlug={`${slugs.exam}/${type_array.tsc}`} newSlug={""}
        location={location} Title={"TSC Exam"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}

      />
      {/* <SideBarBlock
        allSlug={`${slugs.exam}/chapter-exam`} newSlug={""}
        location={location} Title={"Chapter Exam "}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}
       
      /> */}
      <SideBarBlock
        allSlug={slugs.daily_exam} newSlug={""}
        location={location} Title={"Exam Packages"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}

      />
      {/* <SideBarBlock
        allSlug={"/classroom"} newSlug={""}
        location={location} Title={"Classroom"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}
       
      /> */}
      {/* <SideBarBlock
        allSlug={slugs.daily_exam} newSlug={""}
        location={location} Title={"My Batch Exam"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}
       
      /> */}
      <SideBarBlock
        allSlug={slugs.exam_result_list} newSlug={""}
        location={location} Title={"All Exam Results"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}

      />
      {/* <SideBarBlock
        allSlug={slugs.chapter_wise_exam_result_list} newSlug={""}
        location={location} Title={"Chapter Results"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}
       
      /> */}
      <SideBarBlock
        allSlug={slugs.daily_exam_result_list} newSlug={""}
        location={location} Title={"My Batch Results"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}

      />
      <SideBarBlock
        allSlug={"/profile"} newSlug={""}
        location={location} Title={"Profile"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}

      />
    </div>
  )
}